// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2C0aG","lds-ripple":"Loader_lds-ripple__3Yvuf","center":"Loader_center__1EM4W"};